// Function to apply "Limited Edition" label
function applyLimitedEditionLabels() {
  document.querySelectorAll('.product-label').forEach(function(label) {
    // Skip if already processed
    if (label.classList.contains('limited-edition-label')) return;

    const span = label.querySelector('span');
    if (span && span.textContent.trim().toLowerCase().includes('limited edition')) {
      label.classList.add('limited-edition-label');
      span.style.visibility = 'hidden';
    }
  });
}

// Inject CSS for the limited edition badge (only once)
if (!document.getElementById('limited-edition-badge-styles')) {
  const style = document.createElement('style');
  style.id = 'limited-edition-badge-styles';
  style.innerHTML = `
    @media (min-width:960px){       
      .image-cont.image-cont--with-secondary-image:hover .limited-edition-label::after {
        background-image: url("https://cdn.shopify.com/s/files/1/0725/8213/6047/files/limited-edition-badge-newsprint.svg?v=1733702265") !important;
      }
    }
    .limited-edition-label::after {
      content: '';
      background-image: url(https://cdn.shopify.com/s/files/1/0725/8213/6047/files/limited-edition-badge.svg?v=1733698871);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      width: 100px;
      height: 100px;
      right: 5%;
      top: 15%;
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);
}

// Initial run on page load
applyLimitedEditionLabels();

// Observe the DOM for dynamically added product cards (e.g., search results)
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.querySelector('.product-label')) {
        applyLimitedEditionLabels();
      }
    });
  });
});

// Start observing the body (or change to a more specific container if desired)
observer.observe(document.body, { childList: true, subtree: true });
